import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { checkHasApprovedSubscription } from "../features/auth/Utils";

export const MyClassesOrAllClassesToggle = ({
  showAllClasses,
  setShowAllClasses,
}) => {
  const hasApprovedSubscription = checkHasApprovedSubscription();

  if (!hasApprovedSubscription) {
    return null;
  }
  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setShowAllClasses(newValue);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <ToggleButtonGroup
        value={showAllClasses}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          backgroundColor: "action.hover",
          borderRadius: 999,
          p: 0.2,
          height: 35,
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: 999,
            px: 2,
            textTransform: "none",
          },
          "& .Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        }}
      >
        <ToggleButton value={false}>My Classes</ToggleButton>
        <ToggleButton value={true}>All Classes</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
